import { name } from 'file-loader'
import * as types from './types'

// ----------------------------------
// Login Form ACTIONS
// ----------------------------------
export const changeLoginData = (payload) => ({
    type: types.CHG_LOGIN_DATA,
    payload: payload
})

export const resetFormData = () => ({
    type: types.RESET_FORM_DATA,
    payload: ''
})

export const updateAlertData = (alertModel) => ({
    type: types.UPD_ALERT,
    payload: alertModel
})

export const hideAlert = () => ({
    type: types.HIDE_ALERT,
    payload: ''
})

export const openFAQS = (payload) => ({
    type: types.OPEN_FAQS,
    payload: payload
})

// ----------------------------------
// Status Form ACTIONS
// ----------------------------------
export const changeStatusData = (payload) => ({
    type: types.CHG_STATUS_DATA,
    payload: payload
})

export const setApplicantStatusData = (data) => ({
    type: types.SET_APPLICANT_STATUS_DATA,
    payload: data,
})


// ----------------------------------
// Common ACTIONS
// ----------------------------------
export const isLoading = (loading) => ({
    type: types.IS_LOADING,
    payload: loading,
})

export const setCompanyId = (data) => ({
    type: types.CHG_COMP_ID,
    payload: data,
})

export const setFaqsData = (data) => ({
    type: types.CHG_FAQS_DATA,
    payload: data,
})

export const isError404 = (error) => ({
    type: types.ERR_404,
    payload: error
})

